import 'styles/templates/stores.scss'

import 'scripts/vue/main'

import Vue from 'vue'
import Accordion from 'scripts/vue/components/Accordion'
import AccordionItem from 'scripts/vue/components/AccordionItem'

window.PSTheme.Vue.Stores = new Vue({
  name: 'Stores',

  components: { Accordion, AccordionItem },
  
  props: [ 'blocks' ],

  data () {
    return {
      topIndex: window.location.hash.substr(1) || 1
    }
  }
}).$mount('.stores')
